import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpDropdownComponent } from './fcp-dropdown.component';
import { FcpIconModule } from '../fcp-icon';
import { FcpBadgeModule } from '../fcp-badge';

@NgModule({
    declarations: [FcpDropdownComponent],
    imports: [CommonModule, FcpIconModule, FcpBadgeModule],
    exports: [FcpDropdownComponent]
})
export class FcpDropdownModule {}
